import { StoreState } from "store";

export const whitelabelAncillariesSelector = (state: StoreState) => state.whitelabelAncillaries;
export const whitelabelAncillariesLoadingSelector = (state: StoreState) =>
  state.whitelabelAncillaries.whitelabelAncillariesLoading;
